{
	"title": "Start",
	"welcome": "Welkom, {{name}}.",
	"revenue": {
		"title": "Omzet",
		"more": "Omzet bekijken",
		"today": "Vandaag",
		"week": "Deze week",
		"month": "Deze maand",
		"split": "Particulier {{consumer}} · zakelijk {{business}}",
		"exclVat": "Exclusief btw, met refunds eraf."
	},
	"queue": {
		"title": "Te doen",
		"nothing": "Er staat niets klaar. Lekker bezig!",
		"attention": {
			"title": "Aandacht nodig",
			"empty": "Niets om na te kijken."
		},
		"toShip": {
			"title": "Te verzenden",
			"empty": "Alles is verzonden.",
			"all": "Alle te verzenden orders"
		},
		"overdue": {
			"title": "Vervallen facturen",
			"empty": "Geen vervallen facturen.",
			"all": "Alle vervallen facturen ({{amount}})",
			"days_one": "{{count}} dag over {{date}}",
			"days_other": "{{count}} dagen over {{date}}",
			"reminders_one": "{{count}} herinnering",
			"reminders_other": "{{count}} herinneringen"
		},
		"applications": {
			"title": "Zakelijke aanvragen",
			"empty": "Geen aanvragen om te beoordelen.",
			"all": "Alle aanvragen"
		},
		"stock": {
			"title": "Voorraad",
			"empty": "Niets is op of bijna op.",
			"out": "Op",
			"low": "Nog {{quantity}}",
			"allOut_one": "{{count}} variant op",
			"allOut_other": "{{count}} varianten op",
			"allLow_one": "{{count}} variant bijna op",
			"allLow_other": "{{count}} varianten bijna op"
		},
		"backgroundFailures": {
			"title": "Mislukt op de achtergrond",
			"empty": "Niets mislukt.",
			"help": "Vraagt een klant ernaar, laat het dan opnieuw proberen. Het volledige adres en de fout staan in de log.",
			"work": {
				"registration": "Registreren",
				"passwordReset": "Wachtwoord vergeten",
				"confirmationResend": "Nieuwe bevestigingslink"
			},
			"failure": {
				"mailNotSent": "mail niet verstuurd",
				"error": "fout"
			},
			"resolve": "Afgehandeld",
			"failed": "Dat lukte niet. Probeer het nog eens."
		},
		"reviews": {
			"title": "Reviews te beoordelen",
			"empty": "Geen reviews om te beoordelen.",
			"all": "Alle te beoordelen reviews"
		}
	},
	"help": {
		"start": {
			"title": "Start",
			"area": "Start",
			"short": "Wat er nu speelt: de omzet van vandaag, deze week en deze maand, wat er te doen is, en of de systemen werken. Klik op een regel om er meteen mee aan de slag te gaan.",
			"terms": ["start:revenue", "start:queue", "health:health"]
		},
		"revenue": {
			"title": "Omzet op Start",
			"area": "Start › Omzet",
			"short": "Drie kaarten: vandaag, deze week (vanaf maandag) en deze maand (vanaf de 1e), steeds tot nu. Onder het totaal staat het deel particulier en zakelijk. Een klik opent Omzet met die periode.",
			"terms": ["revenue:counts", "revenue:segments", "revenue:revenue"],
			"goTo": {
				"to": "/revenue",
				"label": "Naar Omzet"
			}
		},
		"queue": {
			"title": "Te doen",
			"area": "Start › Te doen",
			"short": "Wat er op je wacht, per soort werk: het aantal en de eerste paar, de oudste eerst. Klik op een regel om het af te handelen. Is alles af, dan staat er niets klaar.",
			"terms": [
				"start:attention",
				"start:toShip",
				"start:overdue",
				"start:applications",
				"start:reviews",
				"start:stock",
				"start:backgroundFailures"
			]
		},
		"attention": {
			"title": "Aandacht nodig",
			"area": "Start › Te doen",
			"short": "Orders waarbij je iets moet doen: de betaling of de voorraad controleren, terugbetalen, de factuur maken of het verzendadres nakijken. Klaar? Klik op de knop ernaast, dan verdwijnt de regel.",
			"warning": "De knop zet alleen de melding uit. Het werk zelf, zoals terugbetalen, doe je in de order.",
			"terms": ["order:order"]
		},
		"toShip": {
			"title": "Te verzenden",
			"area": "Start › Te doen",
			"short": "Betaalde orders en orders op rekening die nog geen track & trace hebben, de oudste eerst. Een order gaat van de lijst zodra je hem verzendt.",
			"terms": ["order:order", "order:paymentStatus"],
			"goTo": {
				"to": "/order",
				"label": "Naar Orders"
			},
			"warning": "Een geannuleerde order staat er niet tussen, en een order met een nieuw verzendadres pas als je dat adres hebt gecontroleerd (onder Aandacht nodig)."
		},
		"overdue": {
			"title": "Vervallen facturen",
			"area": "Start › Te doen",
			"short": "Facturen van orders op rekening die over hun betaaltermijn heen zijn, de langst vervallen eerst. Je ziet hoeveel dagen te laat en hoeveel herinneringen er al zijn. Onderaan staat het totaal dat openstaat.",
			"terms": ["order:order"]
		},
		"applications": {
			"title": "Zakelijke aanvragen",
			"area": "Start › Te doen",
			"short": "Klanten die een zakelijk account aanvroegen en op je besluit wachten. Open de klant om de aanvraag goed te keuren of af te wijzen.",
			"goTo": {
				"to": "/customer",
				"label": "Naar Klanten"
			}
		},
		"reviews": {
			"title": "Reviews te beoordelen",
			"area": "Start › Te doen",
			"short": "Reviews die klanten schreven en die nog niet in de shop staan, de oudste eerst. Open er een om hem goed te keuren of af te wijzen.",
			"goTo": {
				"to": "/product-review",
				"label": "Naar Reviews"
			}
		},
		"stock": {
			"title": "Voorraad",
			"area": "Start › Te doen",
			"short": "Actieve varianten die op zijn of bijna op. Bijna op is vanaf 1 tot en met het aantal bij \"Bijna op bij\" van het product. Klik op een variant om de voorraad te zien of te boeken.",
			"goTo": {
				"to": "/stock",
				"label": "Naar Voorraad"
			}
		},
		"backgroundFailures": {
			"title": "Mislukt op de achtergrond",
			"area": "Start › Te doen",
			"short": "Een mail die de shop zelf stuurt en die niet aankwam: bij registreren, bij wachtwoord vergeten of een nieuwe bevestigingslink. Het mailadres staat half verborgen. Is het opgelost, klik dan op Afgehandeld."
		}
	}
}
